import { Request } from '@/classes/Request'

export const submitContractRevision = async (
  contractRevisionId: number,
  paymentPlanId: number | null,
  paymentDay: number | null,
  fundingSourceId: number,
  signature: string,
  confirmAutoPayments: boolean,
  selectedIntervalBillingScheduleId: number,
  // Auto-pay trigger chosen in this modal. The backend uses it to create the account's
  // auto-pay settings row when the family does not have one yet (DTA-895), so enrolling
  // at signing no longer leaves auto pay switched on with nothing on the account to show
  // for it. Omitted => the backend charges on each invoice's due date.
  autoPayDay: number | null = null,
  contInvoiceDueDate: boolean | null = null
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/contract_revision/submit`, {
        contract_revision_id: contractRevisionId,
        payment_plan_id: paymentPlanId,
        payment_day: paymentDay,
        funding_source_id: fundingSourceId,
        signature: signature,
        confirm_auto_payments: confirmAutoPayments,
        selected_interval_billing_schedule_id: selectedIntervalBillingScheduleId,
        auto_pay_day: autoPayDay,
        cont_invoice_due_date: contInvoiceDueDate
      })
      .then(response => {
        // The backend returns 200 with { error: '...' } on validation
        // failures; treat those as rejections so callers don't show a
        // false success.
        if (response.data && response.data.error) {
          reject(new Error(response.data.error))
          return
        }
        resolve(response.data.invoice_header_id)
      })
      .catch(error => {
        reject(error)
      })
  })
}
